const REFERRAL_CODE_STORAGE_KEY = 'hy_ref_code';
const REFERRAL_CODE_COOKIE = 'hy_ref_code';
const REFERRAL_CODE_PATTERN = /^[A-Z2-9]{8}$/i;
const THIRTY_DAYS_SECONDS = 30 * 24 * 60 * 60;

function validCode(value) {
  return typeof value === 'string' && REFERRAL_CODE_PATTERN.test(value);
}

function readReferralCookie() {
  if (typeof document === 'undefined') return null;

  const prefix = `${REFERRAL_CODE_COOKIE}=`;
  const entry = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));
  const value = entry?.slice(prefix.length) || null;
  return validCode(value) ? value.toUpperCase() : null;
}

function writeReferralCookie(code) {
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${REFERRAL_CODE_COOKIE}=${code}; Max-Age=${THIRTY_DAYS_SECONDS}; Path=/; SameSite=Lax${secure}`;
}

/** Read localStorage first, then use the cookie fallback when storage is blocked. */
export function readStoredReferralCode() {
  if (typeof window === 'undefined') return null;

  try {
    const stored = window.localStorage.getItem(REFERRAL_CODE_STORAGE_KEY);
    if (validCode(stored)) return stored.toUpperCase();
  } catch (error) {
    console.error('Referral code could not be read from localStorage. Using the cookie fallback.', error);
  }

  return readReferralCookie();
}

/**
 * Capture a valid referral code without replacing the first code seen.
 * Cross-device waitlist continuation cannot preserve attribution until sign-in.
 */
export function captureReferralCode() {
  if (typeof window === 'undefined') return null;

  const existing = readStoredReferralCode();
  if (existing) return existing;

  const code = new URLSearchParams(window.location.search).get('ref');
  if (!validCode(code)) return null;

  const normalized = code.toUpperCase();
  try {
    window.localStorage.setItem(REFERRAL_CODE_STORAGE_KEY, normalized);
  } catch (error) {
    // The 30-day cookie keeps same-device and cross-tab attribution available
    // when localStorage is blocked.
    console.error('Referral code could not be stored in localStorage. Using the cookie fallback.', error);
  }
  writeReferralCookie(normalized);
  return normalized;
}

/** Clear both persistence locations after a terminal attribution outcome. */
export function clearStoredReferralCode() {
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.removeItem(REFERRAL_CODE_STORAGE_KEY);
    } catch (error) {
      console.error('Referral code could not be cleared from localStorage.', error);
    }
  }

  if (typeof document !== 'undefined') {
    document.cookie = `${REFERRAL_CODE_COOKIE}=; Max-Age=0; Path=/; SameSite=Lax`;
  }
}

export { REFERRAL_CODE_PATTERN, REFERRAL_CODE_STORAGE_KEY };
